import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Estimate requested", { props: { triggerType: "Form Submitted", event: "Get a quote form" } }],
  ["nt", "auto-notify", "New estimate request", { props: { channel: "sms", message: "Quote request: {{contact.full_name}} — {{contact.job_type}}" } }],
  ["k1", "auto-task", "Price the job and send it", { props: { assignee: "Estimator", due: "+1 day" } }],
  ["e1", "auto-email", "Your estimate", { props: { subject: "Your quote for {{contact.job_type}}" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e2", "auto-email", "Any questions on the quote?", { props: { subject: "Anything you'd like me to explain?" } }],
  ["w2", "auto-wait", "Wait 4 days", { props: { duration: "4", unit: "days" } }],
  ["s1", "auto-sms", "Hold the slot?", { props: { message: "Still want us to hold the date? Happy to adjust the quote." } }],
  ["c1", "auto-condition", "Job accepted?", { props: { condition: "Has tag 'job-won'" } }],
  ["p1", "auto-pipeline", "Move to Won", { props: { pipeline: "Jobs", stage: "Won — scheduled" } }],
]);

const def: TemplateDef = {
  slug: "estimate-to-job-won",
  name: "Estimate → Job Won",
  category: "Services",
  tagline:
    "Quote fast, follow up three times, and stop losing jobs to silence.",
  description:
    "A free quote follow-up template for trades and service businesses: an estimate request alerts the estimator and creates a task, the quote goes out, then two follow-ups and a text run automatically until the job is won or lost. Clone it into FrazzleCRM and the follow-up stops depending on memory.",
  whatsInside: [
    "Quote form wired to an instant SMS alert and a pricing task",
    "Estimate email plus two spaced follow-ups and a closing text",
    "Accepted? branch that moves the job through your pipeline",
    "One place to see why quotes go quiet — the map is the process",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-google", "Google Ads", 40, 60, { props: { campaign: "Local service intent" } }),
      node("src2", "traffic-seo", "Local SEO / Maps", 40, 220, { props: { keywords: "service + near me" } }),
      node("fm", "page-web", "Get a quote", 360, 140, { props: { pageType: "opt-in", headline: "Free estimate in 24 hours" } }),
      flow("f1", "Quote Follow-Up", 680, 40, 420, 1040),
      ...seq.nodes,
      node("out", "outcome-won", "Job won", 1200, 340, { props: { value: "$2,400 avg" } }),
      node("n1", "util-note", "Most quotes die at follow-up two", 360, 340, {
        notes:
          "The quote itself is rarely the problem — the silence after it is. Three touches over a week costs nothing and is usually the difference between a won job and a competitor who called back.",
      }),
    ],
    [
      edge("src1", "fm"),
      edge("src2", "fm"),
      edge("fm", "f1"),
      ...seq.edges,
      edge("f1", "out"),
    ]
  ),
};

export default def;
